__turbopack_context__.v({
  "agent-arrow": "style-module-scss-module__TggroW__agent-arrow",
  "agent-bio": "style-module-scss-module__TggroW__agent-bio",
  "agent-card": "style-module-scss-module__TggroW__agent-card",
  "agent-info": "style-module-scss-module__TggroW__agent-info",
  "agent-license": "style-module-scss-module__TggroW__agent-license",
  "agent-location": "style-module-scss-module__TggroW__agent-location",
  "agent-name": "style-module-scss-module__TggroW__agent-name",
  "agent-photo": "style-module-scss-module__TggroW__agent-photo",
  "agent-photo-exp-logo": "style-module-scss-module__TggroW__agent-photo-exp-logo",
  "agent-photo-initials": "style-module-scss-module__TggroW__agent-photo-initials",
  "agent-photo-wrapper": "style-module-scss-module__TggroW__agent-photo-wrapper",
  "is-commercial": "style-module-scss-module__TggroW__is-commercial",
});
